const fa = require('translations/fa.json');
const en = require('translations/en.json');

export const APP = {
	REQ_STATUS: {
		SUCCESSFUL: 200,
	},
	WEB_CONFIG: [
		{lang: 'fa', translation: fa, dir: 'rtl', fontFamily: 'Samim'},
		{lang: 'en', translation: en, dir: 'ltr', fontFamily: 'Work Sans'},
	],
	INDEXING_EDUCATIONLEVELS: [
		'fellowship', 'sub-specialist'
	],
	JALALI_MONTH: [
		{name: 'فروردین', num: `01`},
		{name: 'اردیبهشت', num: `02`},
		{name: 'خرداد', num: `03`},
		{name: 'تیر', num: `04`},
		{name: 'مرداد', num: `05`},
		{name: 'شهریور', num: `06`},
		{name: 'مهر', num: `07`},
		{name: 'آبان', num: `08`},
		{name: 'آذر', num: `09`},
		{name: 'دی', num: `10`},
		{name: 'بهمن', num: `11`},
		{name: 'اسفند', num: `12`},
	],
	GREGORIAN_MONTH: [
		{name: 'January', num: `01`},
		{name: 'February', num: `02`},
		{name: 'March', num: `03`},
		{name: 'April', num: `04`},
		{name: 'May', num: `05`},
		{name: 'June', num: `06`},
		{name: 'July', num: `07`},
		{name: 'August', num: `08`},
		{name: 'September', num: `09`},
		{name: 'October', num: `10`},
		{name: 'November', num: `11`},
		{name: 'December', num: `12`},
	],
};
